import { Component, OnInit } from "@angular/core";
import { Globals } from "src/app/globals";
import { ConflictosService } from "../servicios/conflictos.service";
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { ConsultarPreguntasService } from "src/app/administrador-preguntas/consultar-preguntas.service";

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: "app-actualizar-conflicto",
  templateUrl: "./actualizar-conflicto.component.html",
  styleUrls: ["./actualizar-conflicto.component.css"]
})
export class ActualizarConflictoComponent implements OnInit {
  tipoPregunta;
  tituloNuevoConflicto;
  tiposConflicto = [];
  grupoRespuestas = [];
  faEdit = faEdit;
  faTimes = faTimes;

  tablaTitulo;
  tablaEstado;
  tablaFechaRegistro;
  tablaComentarios;
  tablaAccion;
  tablaCerrar;

  respuestaSeleccionada;
  idRespuesta;
  infoConflicto;
  infoRespuesta;
  IdActualizacionEstado;

  mostrarTabla = false;
  cerrarConflicto = false;

  displayedColumns: string[] = [
    "titulo",
    "estado",
    "fechaRegistro",
    "comentarios",
    "accion",
    "cerrar"
  ];
  origenDatos = [];

  constructor(
    public global: Globals,
    private conflictosService: ConflictosService,
    private ConsultarPreguntas: ConsultarPreguntasService,
  ) {}

  ngOnInit() {
    this.global.conflictosEditarConflicto = true;

    if (this.global.lenguaje == "es") {
      this.tituloNuevoConflicto = "Lista de conflictos creados";
      this.tablaTitulo = "Titulo";
      this.tablaEstado = "Estado";
      this.tablaFechaRegistro = "Año";
      this.tablaComentarios = "Comentarios";
      this.tablaAccion = "Editar";
      this.tablaCerrar = "Eliminar Conflicto";
    } else {
      this.tituloNuevoConflicto = "List of created conflicts";
      this.tablaTitulo = "Title";
      this.tablaEstado = "State";
      this.tablaFechaRegistro = "Year";
      this.tablaComentarios = "Comments";
      this.tablaAccion = "Edit";
      this.tablaCerrar = "Remove Conflict";
    }

    let etiquetaCargando = { es: "Cargando", en: "Loading" };
    Swal.fire(etiquetaCargando[this.global.lenguaje]);
    Swal.showLoading();

    this.conflictosService
      .consultarNumeroConflictosPorPregunta(
        this.global.IdFuncionarioTablaFuncionarios
      )
      .subscribe(datos => {
        Swal.close();
        //////conole.log(datos);
        let preguntas = <any[]>datos;
        for (let i = 0; i < preguntas.length; i++) {
          const pregunta = preguntas[i];
          let conflicto = { tipo: pregunta["tipo"] };
          conflicto["titulo"] = pregunta[this.global.lenguaje];
          conflicto["cantidad"] = pregunta["cantidad"];
          if (pregunta["cantidad"] > 0) {
            this.tiposConflicto.push(conflicto);
          }
        }
      });
  }

  seleccionarPregunta(objetoTipo) {
    this.mostrarTabla = false;
    this.origenDatos = [];
    this.grupoRespuestas = [];
    this.tipoPregunta = objetoTipo.tipo;
    this.conflictosService
      .consultarRepuestas(this.global.IdFuncionarioTablaFuncionarios, this.tipoPregunta)
      .subscribe(datos => {
        //////conole.log("Aquiiiiiiiiiiiiiiiiiiiiiiiii");
        //////conole.log(datos);
        let respuestas = datos["Respuestas"];
        for (let i = 0; i < respuestas.length; i++) {
          const respuesta = respuestas[i];
          let infoRespuesta = respuesta[0];
          //////conole.log("INFO RESPUESTA", infoRespuesta)
          let estado = infoRespuesta["estado_conflicto"]
            ? infoRespuesta["estado_conflicto"]
            : "Registrado";
          let fechaRegistro = infoRespuesta["fecha_registro"]
            ? infoRespuesta["fecha_registro"]
            : "-";
          let comentarios = infoRespuesta["comentarios"]
            ? infoRespuesta["comentarios"]
            : "-";
          
            let accionok = infoRespuesta["accion"];
          
          
            let objetoRespuesta = {
            titulo: objetoTipo.titulo,
            estado,
            fechaRegistro,
            comentarios,
            indice: i,
            acciondato: accionok
          };
          this.origenDatos.push(objetoRespuesta);
          this.grupoRespuestas.push(respuesta);
        }
        //////conole.log("origenDatos:", this.origenDatos);
        //////conole.log("grupoRespuestas:", this.grupoRespuestas);
        this.mostrarTabla = true;
      });
  }

  editar(indice) {
    let respuesta = this.grupoRespuestas[indice];
    this.respuestaSeleccionada = {};
    //////conole.log("respuestaaaaaaaaaaaaaaaaaaaaaaaaaaaa:", respuesta);
    for (let i = 0; i < respuesta.length; i++) {
      const campo = respuesta[i];
      let id = campo["id_tipo_respuesta"];
      let valor = campo["valor"];
      let idRespuestaIndividual = campo["idtbl_respuestas_adicionales"];
      let idRespuestaConflicto = campo["idtbl_respuesta_conflicto"];
      this.respuestaSeleccionada[id] = {
        valor,
        idRespuestaIndividual,
        idRespuestaConflicto
      };
    }

    this.global.conflictosPreguntaGlobal = true;
    this.mostrarTabla = false;
  }


  

  cerrar(indice,conflicto) {

    //////conole.log("indiceee",indice);

    this.infoConflicto=conflicto;
   
   let idConflictoRec;

    let respuesta = this.grupoRespuestas[indice];
    let respuestaSeleccionada1 = {};
    
    //////conole.log("respuestaaaaaaaaaaaaaaaaaaaaaaaaaaaa:", respuesta);
    
    for (let i = 0; i < respuesta.length; i++) {

      const campo = respuesta[i];
      let id = campo["id_tipo_respuesta"];
      let valor = campo["valor"];
      let idRespuestaIndividual = campo["idtbl_respuestas_adicionales"];
      let idRespuestaConflicto = campo["idtbl_respuesta_conflicto"];
      idConflictoRec=idRespuestaConflicto
      respuestaSeleccionada1[id] = {
        valor,
        idRespuestaIndividual,
        idRespuestaConflicto
      };

     
    }

   // this.infoRespuesta=this.grupoRespuestas[0]
    //console.log(idConflictoRec)
    this.ConsultarPreguntas.ConsultarConflictoNoExiste(this.global.IdFuncionarioTablaFuncionarios, 1,idConflictoRec).subscribe(rt=>{
      //console.log(rt)
      this.infoRespuesta= rt[0]
    })

   

    try {      
    this.IdActualizacionEstado = respuestaSeleccionada1[32].idRespuestaIndividual
      
    } catch (error) {
      this.IdActualizacionEstado = 0;
    }


    //////conole.log(this.IdActualizacionEstado);  
    

     this.mostrarTabla = false;
     let respuesta2 = this.grupoRespuestas[indice];
     const campo2 = respuesta2[0];
     this.idRespuesta = campo2["idtbl_respuesta_conflicto"];
     
     this.cerrarConflicto = true;
  }
}
